import { Hero } from '@/components/renters/Hero';
import { PRODUCT_HOME_US_RENTERS } from '@/components/shared/BuildByYou/defaults';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SectionEventWrapper } from '@/components/shared/SectionEventWrapper';
import { SEO } from '@/components/shared/SEO';
import type { Config } from '@/pageConfig/renters';
import { Box } from '@lemonade-hq/cdk';
import dynamic from 'next/dynamic';
import type React from 'react';

const Protected = dynamic(() => import('@/components/renters/Protected'));
const Products = dynamic(() => import('@/components/shared').then(mod => mod.Products));
const GetCovered = dynamic(() => import('@/components/renters/GetCovered').then(mod => mod.GetCovered));
const Claims = dynamic(() => import('@/components/renters/Claims').then(mod => mod.Claims));
const Faq = dynamic(() => import('@/components/renters/Faq').then(mod => mod.Faq));
const BottomCTA = dynamic(() => import('@/components/renters/BottomCTA').then(mod => mod.BottomCTA));
const BottomLogos = dynamic(() => import('@/components/renters/BottomLogos'));
const Coverage = dynamic(() => import('@/components/homeowners/coverage/Coverage').then(mod => mod.Coverage));
const CustomersReviews = dynamic(() => import('@/components/shared').then(mod => mod.CustomersReviews));

const componentsByName = {
  hero: Hero,
  customersReviews: CustomersReviews,
  claims: Claims,
  protected: Protected,
  faq: Faq,
  coverage: GetCovered,
  frCoverage: Coverage,
  bottomCTA: BottomCTA,
  bottomLogos: BottomLogos,
  products: Products,
} as const;

interface RentersPageTemplateProps {
  config: Config;
}

export const RentersPageTemplate: React.FC<RentersPageTemplateProps> = ({ config }) => {
  return (
    <Box position="relative" overflowX="hidden">
      <Layout {...config.layout} product={PRODUCT_HOME_US_RENTERS}>
        <SEO {...config.seo} />
        <PageWrapper>
          {Object.entries(config).map(([componentName, componentProps]) => {
            if (componentName === 'seo' || componentName === 'layout') return null;

            const Component = componentsByName[componentName as keyof typeof componentsByName];

            if (Component == null) {
              console.error(`Component ${componentName} not found`);
              return null;
            }

            return (
              <SectionEventWrapper key={componentName} name={componentName} page="renters">
                <Component {...componentProps} {...componentProps.layout} />
              </SectionEventWrapper>
            );
          })}
        </PageWrapper>
      </Layout>
    </Box>
  );
};
